import Fingerprint2 from 'fingerprintjs2';
import globalConfig from './globalConfig';
const FINGER_PRINT = 'fingerPrint';

export const getFingerprint = function () {
  let oldFinterPrint = globalConfig.getLclStorageItem(FINGER_PRINT);
  if (oldFinterPrint) {
    return oldFinterPrint;
  } else {
    Fingerprint2.getV18(
      {
        excludes: {
          language: true,
        },
      },
      function (result) {
        let timestamp = new Date().valueOf();
        let finterPrint = result + timestamp;
        globalConfig.setLclStorageItem(FINGER_PRINT, finterPrint);
        return finterPrint;
      }
    );
  }
};
